var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number",class:( _obj = { 'show-arrow': _vm.shouldShowArrow}, _obj[_vm.previous] = true, _obj )})}
var staticRenderFns = []

export { render, staticRenderFns }